// src/hooks/useProfesPerPage.ts
import { useState, useEffect } from 'react';

/**
 * 🧩 useProfesPerPage
 * Hook personalizado que ajusta dinámicamente la cantidad de profesionales
 * a mostrar por página según el tamaño de la ventana.
 *
 * - En pantallas pequeñas (<=768px): 12 profesionales por página
 * - En pantallas grandes (>768px): 15 profesionales por página
 */

const useProfesPerPage = () => {
  // 🔹 Estado que almacena la cantidad de profesionales por página
  const [profesPerPage, setProfesPerPage] = useState<number>(4);

  useEffect(() => {
    /**
     * 🔸 handleResize
     * Ajusta `profesPerPage` según el ancho de la ventana
     */
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        // 🟢 Pantallas pequeñas → más profesionales visibles para mejor scroll
        setProfesPerPage(12);
      } else {
        // 🟢 Pantallas grandes → menos profesionales por página para mantener el diseño
        setProfesPerPage(18);
      }
    };

    // 🔹 Ejecutar al cargar para establecer valor inicial correcto
    handleResize();

    // 🔹 Agregar listener de resize
    window.addEventListener('resize', handleResize);

    // 🔹 Cleanup: eliminar listener al desmontar
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 🔹 Retorna cantidad de profesionales por página
  return profesPerPage;
};

export default useProfesPerPage;
